<template>
  <!--
    中间地图区：与父级 flex 列同宽；在 V3 三栏等高时父列为 column+stretch，本区 flex:1 占满顶栏与底部统计之间的剩余高度，地图随容器增高。
  -->
  <div class="centerMap">
    <CustomizeChinaMapChart
      class="centerMap__chart"
      embedded
      id="kfsl2"
      path="clinic_kfsl_v2"
      :key="this.$store.state.query_flag+this.$store.state.date_value"
      :params="{
        date_start: this.$store.state.date_value[0],
        date_end: this.$store.state.date_value[1],
        query_var: this.$store.state.query_var,
        query_cond: this.$store.state.query_cond,
        query_value: this.$store.state.query_value
      }"
    />
  </div>
</template>

<script>
import CustomizeChinaMapChart from "@/views/charts/customizechinamap";

export default {
  name: "centerMap",
  components: {
    CustomizeChinaMapChart,
  },
  data() {
    return {
      query_flag: 0,
      date_value: ['2021-12-13 00:00:00', '2021-12-14 23:00:00'],
      query_var: "",
      query_cond: "",
      query_value: "",
    }
  },
}
</script>
<style scoped>
.centerMap {
  /** 在 center-main-container 竖直 flex 中吃掉剩余高度，使地图与左侧同栏时等高无大块空白 */
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

/** 与地图组件一并铺满 .centerMap 分配高度（父级已有确定高度，height:100% 有效） */
.centerMap__chart {
  flex: 1 1 0;
  min-height: 0;
  min-width: 0;
  width: 100%;
  max-width: 100%;
}
</style>
